import _ from "lodash";

export const EVIDENCE_TABS = [
  {
    label: "ประวัติการชำระค่างวด",
    value: 1,
  },
  {
    label: "ประวัติการชำระเงินค่าธรรมเนียม",
    value: 2,
  },
  {
    label: "ประวัติการเพิ่มค่าธรรมเนียม",
    value: 3,
  },
];

export const LEASING_REQUEST_STATUS_OPTIONS = [
  {
    label: "All Status",
    value: "",
  },
  {
    label: "รับคำร้อง",
    value: "รับคำร้อง", //WAIT APPROVE RETURN
  },
  {
    label: "รออนุมัติ",
    value: "รออนุมัติ", //WAIT APPROVE RETURN
  },
  {
    label: "รอผู้ยื่นคำร้องแก้ไข",
    value: "รอผู้ยื่นคำร้องแก้ไข", //WAIT APPROVE RETURN
  },
  {
    label: "รอติดต่อบุคคลอ้างอิง",
    value: "รอติดต่อบุคคลอ้างอิง",
  },
  {
    label: "อนุมัติ",
    value: "อนุมัติ",
  },
  {
    label: "รอนัดหมาย",
    value: "รอนัดหมาย",
  },
  {
    label: "นัดหมายแล้ว",
    value: "นัดหมายแล้ว",
  },
  {
    label: "รอตรวจ",
    value: "รอตรวจ",
  },
  {
    label: "งานสำเร็จแล้ว",
    value: "งานสำเร็จแล้ว",
  },
  {
    label: "ไม่สมบูรณ์",
    value: "ไม่สมบูรณ์",
  },
  {
    label: "ไม่ผ่าน",
    value: "ไม่ผ่าน",
  },
  {
    label: "ยกเลิก",
    value: "ยกเลิก",
  },
  {
    label: "ยืนยัน",
    value: "ยืนยัน",
  },
  {
    label: "สมบูรณ์",
    value: "สมบูรณ์",
  },
  {
    label: "สิ้นสุด",
    value: "สิ้นสุด",
  },
  {
    label: "โอนเงินไม่สำเร็จ",
    value: "โอนเงินไม่สำเร็จ",
  },
];

export const LEASING_REQUEST_PURPOSE_OPTIONS = [
  {
    label: "All Package",
    value: "",
  },
  {
    label: "จำนำ",
    value: "NTF",
  },
  {
    label: "เช่าซื้อ",
    value: "TF",
  },
];

export const RESERVE_OPTIONS = [
  {
    label: "ทั้งหมด",
    value: "",
  },
  { label: "จอง (แสดงเฉพาะของตัวเอง)", value: "RESERVE" },
  { label: "ยังไม่ได้จอง", value: "NOT_RESERVE" },
];

export const LIMIT_OPTIONS = [
  {
    label: 50,
    value: 50,
  },
  { label: 100, value: 100 },
  { label: 150, value: 150 },
  { label: 200, value: 200 },
  { label: 250, value: 250 },
  { label: 300, value: 300 },
];

export const STATUS_OPTIONS = [
  {
    label: "All Status",
    value: "",
  },
  {
    label: "ACTIVE",
    value: "ACTIVE",
  },
  {
    label: "DONE",
    value: "DONE",
  },
  {
    label: "LATE",
    value: "LATE",
  },
  {
    label: "PENDING",
    value: "PENDING",
  },
  {
    label: "CANCEL",
    value: "CANCEL",
  },
  {
    label: "REFINANCE",
    value: "REFINANCE",
  },
  {
    label: "FAIL",
    value: "FAIL",
  },
];

export const BANK_OPTIONS = [
  {
    label: "ธนาคารที่ต้องการรับเงิน",
    value: "ธนาคารที่ต้องการรับเงิน",
  },
  {
    label: "ธนาคารกรุงไทย(KTB)",
    value: "ธนาคารกรุงไทย(KTB)",
  },
  {
    label: "ธนาคารกรุงเทพ(BBL)",
    value: "ธนาคารกรุงเทพ(BBL)",
  },
  {
    label: "ธนาคารกสิกรไทย(KBANK)",
    value: "ธนาคารกสิกรไทย(KBANK)",
  },
  {
    label: "ธนาคารกรุงศรีอยุธยา(BAY)",
    value: "ธนาคารกรุงศรีอยุธยา(BAY)",
  },
  {
    label: "ธนาคารไทยพาณิชย์(SCB)",
    value: "ธนาคารไทยพาณิชย์(SCB)",
  },
  {
    label: "ธนาคารทีเอ็มบีธนชาต(TTB)",
    value: "ธนาคารทีเอ็มบีธนชาต(TTB)",
  },
  {
    label: "ธนาคารซีไอเอ็มบีไทย(CIMB)",
    value: "ธนาคารซีไอเอ็มบีไทย(CIMB)",
  },
  {
    label: "ธนาคารยูโอบี(UOB)",
    value: "ธนาคารยูโอบี(UOB)",
  },
];

export const DEBT_OPTIONS = [
  {
    label: "สินเชื่อ",
    value: "สินเชื่อ",
  },
  {
    label: "บัตรเครดิต",
    value: "บัตรเครดิต",
  },
  {
    label: "ที่พักอาศัย",
    value: "ที่พักอาศัย",
  },
  {
    label: "ยานพาหนะ",
    value: "ยานพาหนะ",
  },
];

export const provinces = [
  "กรุงเทพมหานคร",
  "กระบี่",
  "กาญจนบุรี",
  "กาฬสินธุ์",
  "กำแพงเพชร",
  "ขอนแก่น",
  "จันทบุรี",
  "ฉะเชิงเทรา",
  "ชลบุรี",
  "ชัยนาท",
  "ชัยภูมิ",
  "ชุมพร",
  "เชียงราย",
  "เชียงใหม่",
  "ตรัง",
  "ตราด",
  "ตาก",
  "นครนายก",
  "นครปฐม",
  "นครพนม",
  "นครราชสีมา",
  "นครศรีธรรมราช",
  "นครสวรรค์",
  "นนทบุรี",
  "นราธิวาส",
  "น่าน",
  "บึงกาฬ",
  "บุรีรัมย์",
  "ปทุมธานี",
  "ประจวบคีรีขันธ์",
  "ปราจีนบุรี",
  "ปัตตานี",
  "พระนครศรีอยุธยา",
  "พังงา",
  "พัทลุง",
  "พิจิตร",
  "พิษณุโลก",
  "เพชรบุรี",
  "เพชรบูรณ์",
  "แพร่",
  "พะเยา",
  "ภูเก็ต",
  "มหาสารคาม",
  "มุกดาหาร",
  "แม่ฮ่องสอน",
  "ยะลา",
  "ยโสธร",
  "ร้อยเอ็ด",
  "ระนอง",
  "ระยอง",
  "ราชบุรี",
  "ลพบุรี",
  "ลำปาง",
  "ลำพูน",
  "เลย",
  "ศรีสะเกษ",
  "สกลนคร",
  "สงขลา",
  "สตูล",
  "สมุทรปราการ",
  "สมุทรสงคราม",
  "สมุทรสาคร",
  "สระแก้ว",
  "สระบุรี",
  "สิงห์บุรี",
  "สุโขทัย",
  "สุพรรณบุรี",
  "สุราษฎร์ธานี",
  "สุรินทร์",
  "หนองคาย",
  "หนองบัวลำภู",
  "อ่างทอง",
  "อุดรธานี",
  "อุทัยธานี",
  "อุตรดิตถ์",
  "อุบลราชธานี",
  "อำนาจเจริญ",
];
